// src/features/permissions/components/UserAccessCard.tsx
import { Card } from '../../../app/components/foundation';
import type { RoleUser } from '../data/permissions.mock';

export interface UserAccessCardProps {
  users: RoleUser[];
}

/**
 * Workspace card: users currently assigned to this role — name and
 * email. Rows come straight from the `users` prop (sourced via
 * usePermissionWorkspaceMock) — no fetching here. Same list markup as
 * security/components/SecuritySessionsCard.tsx.
 */
export function UserAccessCard({ users }: UserAccessCardProps) {
  return (
    <Card className="vania-permissions-workspace-card">
      <h2 className="vania-permissions-workspace-card-title">کاربران دارای دسترسی</h2>

      {users.length === 0 ? (
        <p className="vania-permissions-workspace-empty">کاربری به این نقش اختصاص داده نشده است.</p>
      ) : (
        <ul className="vania-permissions-workspace-list">
          {users.map((user) => (
            <li key={user.id} className="vania-permissions-workspace-list-item">
              <span className="vania-permissions-workspace-list-primary">{user.name}</span>
              <span className="vania-permissions-workspace-list-secondary" dir="ltr">
                {user.email}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
